import React, { useState } from "react";
import {
  FormControl,
  Stack,
  RadioGroup,
  Container,
  FormControlLabel,
  Modal,
  Hidden,
  TextField,
  Radio,
  Button,
  FormGroup,
  Checkbox,
  Badge,
  Typography,
  ButtonGroup,
  Box,
  Slider,
} from "@mui/material";
import { useRef } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Axios from "axios";
import Spinner from "./assetStyle/Spinner";

const Getpricing = () => {
  const form = useRef();
  const [inputs, setInputs] = useState({
    stage: "",
    checkbox1: "",
    check1: "",
    Business: "",
  });
  const [count, setCount] = React.useState(1);
  const [count1, setCount1] = React.useState(1);
  const [count2, setCount2] = React.useState(1);
  const [data, setData] = React.useState(2);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState({
    name: "",
    email: "",
    // phone: '',
    comment: "",
  });

  const handleOpen = () => {
    setOpen(true);
    // var x = document.getElementById("postIt");
    // x.style.display = "none";
    // console.log("in opne " + x);
  };
  const handleClose = () => {
    // console.log("in close " + state );
    setOpen(false);
    if (!dberror) {
      window.location.replace("aboutus.html");
    }
  };

  const changeHandler = (event, data) => {
    setData(data);
  };

  const handleInput = (event) => {
    const { name, value } = event.target;
    setUser((prev) => {
      return { ...user, [name]: value };
    });
  };

  const handleChange = (e) => {
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  const handledChange = (count, count1, count2) => {
    setCount(count);
    setCount1(count1);
    setCount2(count2);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    display: "block",
  };

  const design = {
    height: 4,
    width: 4,
    marginRight: 15,
    marginLeft: 15,
    marginTop: 3,
  };

  function valueLabelFormat(value) {
    let scaledValue = value;
    return `${scaledValue} ${"Month"}`;
  }
  const marks = [
    {
      value: 1,
      label: "1 month",
    },
    {
      value: 6,
      label: "6 months",
    },
    {
      value: 12,
      label: "1 year",
    },
    {
      value: 18,
      label: "1.5 years",
    },
    {
      value: 24,
      label: "2 years",
    },
  ];

  //--------------Captcha-Logic-start---------------
  const [state, setState] = useState(Spinner);
  const [usecapcha, setusecapcha] = useState({
    usecapchaname: "",
  });

  const characters = "abc123";

  function generateString(length) {
    let result = "";
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  const captcha = generateString(6); // Function called here and save in captcha variable
  let handleChanged = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    usecapcha[name] = value;
    setusecapcha(usecapcha);
  };

  //-------------Captcha-code--------------
  let dberror = false;

  const handleSubmit = (e) => {

    e.preventDefault();
    var element = document.getElementById("succesBTN");
    var inputData = document.getElementById("inputType");
    element.style.cursor = "wait";
    element.innerHTML = "Checking...";
    inputData.disabled = true;
    element.disabled = true;

    var myFunctions = function () {
      if (captcha === usecapcha.username) {
        element.style.backgroundColor = "green";
        element.innerHTML = "Captcha Verified";
        element.disabled = true;
        element.style.cursor = "not-allowed";
        inputData.style.display = "none";

        Axios.post("https://biztekminds.com/mycoolapp/api/insert_stack", {
          name: user.name,
          email: user.email,
          phone: user.phone,
          comment: user.comment,
          count: count,
          count1: count1,
          count2: count2,
          checkbox1: inputs.checkbox1,
          checkbox2: inputs.checkbox2,
          checkbox3: inputs.checkbox3,
          checkbox4: inputs.checkbox4,
          stage: inputs.stage,
          check1: inputs.check1,
          check2: inputs.check2,
          check3: inputs.check3,
          check4: inputs.check4,
          check5: inputs.check5,
          Business: inputs.Business,
          slider: data,
        })
          .then(function (response) {
            setState(response.data.message);
            console.log(response.data.message);
            // alert(JSON.stringify(response.data.message));
            console.log(response);
            // return setMessage = response.data.message;
          })
          .catch(function (error) {
            dberror = true;
            setState(error.message + " Please try again later");
            console.log(
              "There has been a problem with your fetch operation: " +
              error.message
            );
          });

        handleOpen();
        setTimeout(handleClose, 5000);

        // console.log(inputs + ' these is postIt ' + count + " Middle Developer , " + count1 + " Senior Developer , " + count2 + "  Team Lead , ", data, user);
      } else {
        element.style.backgroundColor = "red";
        element.style.cursor = "not-allowed";
        element.innerHTML = "Not Matched";
        element.disabled = true;
        //  element.disabled = true;
        var myFunction = function () {
          element.style.backgroundColor = "#007bff";
          element.style.cursor = "pointer";
          element.innerHTML = "Verify Captcha";
          element.disabled = false;
          inputData.disabled = false;
          inputData.value = "####";
        };
        setTimeout(myFunction, 1000);
      }
    };
    console.log("after condition");
    setTimeout(myFunctions, 1000);
  };

  const { name, email, comment } = user;
  const enabled =
    name.length > 0 &&
    email.length > 0 &&
    // phone.length > 0 &&
    comment.length > 0;

  return (
    <div className="container" style={{ display: "block" }}>
      <form ref={form} onSubmit={handleSubmit}>
        <Typography variant="h5" sx={{ marginTop: 1, marginBu: 20 }}>
          1. React Developement team
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 5, md: 12 }}
        >
          <div>
            <Box>
              <ButtonGroup sx={{ marginTop: 5 }}>
                <div>
                  <Button
                    aria-label="reduce"
                    variant="outlined"
                    onClick={() => {
                      setCount(Math.max(count - 1, 0));
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    -
                  </Button>
                </div>
                <div style={design}>
                  <Badge
                    onChange={handledChange}
                    value={count}
                    badgeContent={count}
                    name="count4"
                    showZero
                  >
                    {" "}
                  </Badge>
                </div>
                <div>
                  <Button
                    aria-label="increase"
                    onClick={() => {
                      setCount(count + 1);
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    +
                  </Button>
                </div>
                <Box sx={{ marginLeft: "10px", marginTop: "5px" }}>
                  <Typography>Middle Developer</Typography>
                </Box>
              </ButtonGroup>
            </Box>
          </div>

          <div>
            <Box>
              <ButtonGroup sx={{ marginTop: 5 }}>
                <div>
                  <Button
                    aria-label="reduce"
                    onClick={() => {
                      setCount1(Math.max(count1 - 1, 0));
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    -
                  </Button>
                </div>
                <div style={design}>
                  <Badge
                    onChange={handledChange}
                    value={count1}
                    overlap="circular"
                    badgeContent={count1}
                    name="count1"
                    showZero
                  ></Badge>
                </div>
                <div>
                  <Button
                    aria-label="increase"
                    onClick={() => {
                      setCount1(count1 + 1);
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    +
                  </Button>
                </div>
                <Box sx={{ marginLeft: "10px", marginTop: "5px" }}>
                  <Typography>Senior Developer</Typography>
                </Box>
              </ButtonGroup>
            </Box>
          </div>

          <div>
            <Box>
              <ButtonGroup sx={{ marginTop: 5, marginButtom: 5 }}>
                <div>
                  <Button
                    aria-label="reduce"
                    onClick={() => {
                      setCount2(Math.max(count2 - 1, 0));
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    -
                  </Button>
                </div>
                <div style={design}>
                  <Badge
                    onChange={handledChange}
                    value={count2}
                    overlap="circular"
                    badgeContent={count2}
                    name="count2"
                    showZero
                  ></Badge>
                </div>
                <div>
                  <Button
                    aria-label="increase"
                    onClick={() => {
                      setCount2(count2 + 1);
                    }}
                    sx={{ borderRadius: "50%" }}
                  >
                    +
                  </Button>
                </div>
                <Box sx={{ marginLeft: "10px", marginTop: "5px" }}>
                  <Typography>Team Lead</Typography>
                </Box>
              </ButtonGroup>
            </Box>
          </div>
        </Stack>

        <Typography variant="h5" sx={{ marginTop: 5 }}>
          2. What type of software solution would you like to develop with
          Digitize?
        </Typography>

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 1, sm: 5, md: 12 }}
          sx={{ margin: 5 }}
        >
          <FormGroup
            onChange={handleChange}
            sx={{
              color: "action.active",
              display: "flex",
              marginRight: 8,
              marginLeft: 8,
              marginBottom: 6,
              marginTop: 6,
              "& .MuiBadge-root": { marginRight: 4 },
              marginX: 4,
            }}
          >
            <Box>
              <FormControlLabel
                sx={{ marginRight: 16 }}
                value={"Dekstop"}
                name="checkbox1"
                control={<Checkbox />}
                label="Dekstop"
              />
              <FormControlLabel
                sx={{ marginRight: 16 }}
                value={"Mobile"}
                name="checkbox2"
                control={<Checkbox />}
                label="Mobile"
              />
              <FormControlLabel
                sx={{ marginRight: 16 }}
                value={"Web"}
                name="checkbox3"
                control={<Checkbox />}
                label="Web"
              />
              <FormControlLabel
                sx={{ marginRight: 16 }}
                value={"Consultancy needed"}
                name="checkbox4"
                control={<Checkbox />}
                label="Consultancy needed"
              />
            </Box>
          </FormGroup>
        </Stack>

        <Typography variant="h5">
          3. What is the current stage of your software development process?
        </Typography>

        <FormControl>
          <RadioGroup
            defaultValue="female"
            onChange={handleChange}
            name="stage"
            sx={{
              color: "action.active",
              display: "flex",
              marginRight: 8,
              marginLeft: 8,
              marginBottom: 6,
              marginTop: 6,
              "& .MuiBadge-root": { marginRight: 4 },
              marginX: 4,
            }}
          >
            <Box>
              <FormControlLabel
                sx={{ marginRight: 12 }}
                value="Prototype/Specification"
                control={<Radio />}
                label="Prototype/Specification"
              />
              <FormControlLabel
                sx={{ marginRight: 12 }}
                value="Designed solution"
                control={<Radio />}
                label="Designed solution"
              />
              <FormControlLabel
                sx={{ marginRight: 12 }}
                value="MVP"
                control={<Radio />}
                label="MVP"
              />
              <FormControlLabel
                sx={{ marginRight: 12 }}
                value="Mature product"
                control={<Radio />}
                label="Mature product"
              />
            </Box>
          </RadioGroup>
        </FormControl>

        <div className="apple">
          <Typography variant="h5">
            4. Do you need a professional consultation from any of the
            specialists below?
          </Typography>
        </div>
        <FormGroup
          onChange={handleChange}
          sx={{
            color: "action.active",
            display: "flex",
            marginRight: 8,
            marginLeft: 8,
            marginBottom: 6,
            marginTop: 6,
            "& .MuiBadge-root": { marginRight: 4 },
            marginX: 4,
          }}
        >
          <Box>
            <FormControlLabel
              sx={{ marginRight: 8 }}
              value={"Project Manager"}
              name="check1"
              control={<Checkbox />}
              label="Project Manager"
            />
            <FormControlLabel
              sx={{ marginRight: 8 }}
              value={"Business Analyst"}
              name="check2"
              control={<Checkbox />}
              label="Business Analyst"
            />
            <FormControlLabel
              sx={{ marginRight: 8 }}
              value={"UI/UX Designer"}
              name="check3"
              control={<Checkbox />}
              label="UI/UX Designer"
            />
            <FormControlLabel
              sx={{ marginRight: 8 }}
              value={"Architect"}
              name="check4"
              control={<Checkbox />}
              label="Architect"
            />
            <FormControlLabel
              sx={{ marginRight: 8 }}
              value={"Developer"}
              name="check5"
              control={<Checkbox />}
              label="Developer"
            />
          </Box>
        </FormGroup>

        <Typography variant="h5">
          5. Please specify your business industry:
        </Typography>

        <FormControl>
          <RadioGroup
            onChange={handleChange}
            name="Business"
            sx={{
              color: "action.active",
              display: "flex",
              marginBottom: 8,
              marginTop: 6,
            }}
          >
            <Stack
              direction={{ xs: "", sm: "" }}
              spacing={{ xs: 1, sm: 5, md: 12 }}
            >
              <Box>
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Financial Services"
                  control={<Radio />}
                  label="Finalcial Services"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Ecommerce"
                  control={<Radio />}
                  label="Ecommerce"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Travel & Hospitality"
                  control={<Radio />}
                  label="Travel & Hospitality"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Telecom"
                  control={<Radio />}
                  label="Telecom"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Media & Entertainment"
                  control={<Radio />}
                  label="Media & Entertainment"
                />
              </Box>
              <Box>
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Enterprise"
                  control={<Radio />}
                  label="Enterprise"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Real Estate"
                  control={<Radio />}
                  label="Real Estate"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Healthcare"
                  control={<Radio />}
                  label="Healthcare"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="iGaming"
                  control={<Radio />}
                  label="iGaming"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Logistic"
                  control={<Radio />}
                  label="Logistic"
                />
              </Box>
              <Box>
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="eLearning"
                  control={<Radio />}
                  label="eLearning"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Retail"
                  control={<Radio />}
                  label="Retail"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Automotive"
                  control={<Radio />}
                  label="Automotive"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Manufacturing"
                  control={<Radio />}
                  label="Manufacturing"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Aviation"
                  control={<Radio />}
                  label="Aviation"
                />
                <FormControlLabel
                  sx={{ marginRight: 6 }}
                  value="Other"
                  control={<Radio />}
                  label="Other"
                />
              </Box>
            </Stack>
          </RadioGroup>
        </FormControl>

        <Typography sx={{ marginBottom: 5 }} variant="h5">
          6. What is the expected duration of your project?
        </Typography>

        <div>
          <Card sx={{ minWidth: 275, backGround: "none", boxShadow: "none" }}>
            <CardContent>
              <Slider
                value={data}
                name="slider"
                onChange={changeHandler}
                aria-label="month"
                sx={{ marginTop: 3 }}
                defaultValue={1}
                valueLabelDisplay="auto"
                getAriaValueText={valueLabelFormat}
                valueLabelFormat={valueLabelFormat}
                step={1}
                marks={marks}
                min={1}
                max={24}
              />
            </CardContent>
          </Card>
        </div>

        <React.Fragment>
          <Container maxWidth="lg">
            <Stack sx={{ minWidth: 275, marginBottom: "-5" }}>
              <CardContent>
                <div className="container" style={{ display: "block" }}>
                  <Hidden>
                    <TextField type="hidden" variant="standard" />
                  </Hidden>

                  {/* start form */}

                  <div className="sectionTitle">
                    <h2>
                      To receive a quote ,please leave your contact details{" "}
                    </h2>
                    <p>
                      your personal data will be processed securely and won't be
                      available to third parties
                    </p>
                  </div>

                  <div>
                    <div className="form-group col-md-6">
                      <input
                        type="text"
                        placeholder="Name"
                        class="form-control"
                        id="exampleInputName"
                        name="name"
                        onChange={handleInput}
                        value={user.name}
                        required
                      />

                      <Hidden>
                        <TextField
                          type="hidden"
                          placeholder="hidcoun"
                          sx={{ marginX: 3 }}
                          name="count"
                          variant="standard"
                          value={[
                            count +
                            " Middle Developer, " +
                            count1 +
                            " Senior Developer, " +
                            count2 +
                            " Team Lead",
                          ]}
                        />
                      </Hidden>
                    </div>

                    <div className="form-group col-md-6">
                      <input
                        type="email"
                        placeholder="Email"
                        class="form-control"
                        id="exampleInputEmail"
                        name="email"
                        onChange={handleInput}
                        value={user.email}
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <input
                        type="number"
                        placeholder="Phone"
                        class="form-control"
                        id="exampleInputPhone"
                        name="phone"
                        onChange={handleInput}
                        value={user.phone}
                        required
                      />
                    </div>
                    <div className="form-group col-md-10">
                      <textarea
                        className="form-control"
                        placeholder="comment"
                        name="comment"
                        onChange={handleInput}
                        value={user.subject}
                        id="exampleTextarea"
                        rows="6"
                      ></textarea>
                    </div>
                    <Typography
                      variant="h6"
                      component="h2"
                      style={{ margin: "5px 20px 5px 20px" }}
                    >
                      Enter Captcha
                    </Typography>
                    <div className="d-flex align-items-center">
                      <TextField
                        variant="standard"
                        type="text"
                        id="inputType"
                        placeholder="Captcha"
                        name="username"
                        onChange={handleChanged}
                        autoComplete="off"
                        sx={{ marginX: 3 }}
                      />

                      <Typography
                        id="captcha"
                        variant="h4"
                        style={{
                          backgroundColor: "Gray",
                          marginTop: "0rem",
                          marginLeft: "1rem",
                          marginRight: "0rem",
                          position: "relative",
                        }}
                      >
                        {captcha}
                      </Typography>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={!enabled}
                    style={{ marginLeft: "2rem" }}
                    id="succesBTN"
                    onSubmit={handleSubmit}
                    className="btn btn-default btn-primary bold"
                  >
                    Submit
                  </button>

                  {/* end  */}
                </div>

                <Modal
                  hideBackdrop
                  disableAutoFocus
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <Typography variant="h3" sx={{ textAlign: "center" }}>
                      <div
                        id="postIt"
                        style={{ color: "red", display: "block" }}
                      >
                        {state && <div>{state}</div>}
                      </div>
                    </Typography>
                  </Box>
                </Modal>
              </CardContent>
            </Stack>
          </Container>
        </React.Fragment>
      </form>
    </div>
  );
};

export default Getpricing;
